import React from 'react';
import Textarea from 'react-textarea-autosize';

import RadioGroup from '../RadioGroup/RadioGroup';
import FormDropDown from '../FormDropdown/FormDropdown';

import classes from './Input.module.css';
import { IsStringEmpty } from '../../../utilities/CommonMethods';

import infoIcon from '../../../assets/info_icon.png';
import MarkdownInputField from '../../MarkdownInputField/MarkdownInputField';

const Input = (props) => {

  let styleClass = [classes.Label];
  if (IsStringEmpty(props.value) || props.value < 0) {
    styleClass.pop();
    styleClass.push(classes.Label);
  }

  if (props.touched || !IsStringEmpty(props.value)) {
    styleClass.pop();
    styleClass.push(classes.LabelActive);
  }

  let inputElement = null;
  let textAreaInput = false;
  let markdown = false;
  let dropdown = false;
  let radio = false;

  switch (props.elementType) {
    case ('input'):
      inputElement = <input autoComplete={"off"} className={classes.InputElement}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed}
        onKeyDown={props.keyDown !== undefined ? props.keyDown : null}
        disabled={props.disabled} />;
      break;
    case ('textarea'):
      textAreaInput = true;
      // inputElement = <textarea autoComplete={"off"} className={[classes.InputElement, classes.TextArea].join(' ')}
      //   {...props.elementConfig}
      //   value={props.value}
      //   onChange={props.changed}
      //   disabled={props.disabled} />;
      inputElement = <Textarea
        className={[classes.InputElement, classes.TextArea].join(' ')}
        autoComplete={"off"}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed}
        disabled={props.disabled}
        style={{ maxRows: 3 }}
      />
      break;
    case ('markdown'):
      markdown = true;
      inputElement = <MarkdownInputField
        value={props.value}
        onChange={props.changed}
        forEditPage={props.forEditPage}
        showImageOption={props.showImageOption === true}
        fullScreen={props.fullScreen} />
      break;
    case ('checkbox'):
      inputElement = <input className={classes.InputElement}
        {...props.elementConfig}
        value={props.value}
        onChange={props.changed} />;
      break;
    case ('password'):
      inputElement = <input autoComplete={"off"} className={classes.InputElement}
        {...props.elementConfig}
        value={props.value}
        // onKeyDown={props.keyDown !== undefined ? props.keyDown : null}
        onChange={props.changed} />;
      break;
    case ('select'):
      // Log('Select ', props);
      dropdown = true;
      inputElement = <FormDropDown
        inputIdentifier={props.inputIdentifier}
        label={props.label}
        itemList={props.options}
        dropDownOpen={props.dropdownOpen}
        activeItem={(!IsStringEmpty(props.value)) ? parseInt(props.value, 10) : -1}
        onDropDownClicked={props.onDropDownClick}
        onDropDownItemClicked={props.onDropDownItemClick}
        onCreateVideoTitleClick={props.onCreateVideoTitleClick}
        videoTitleShow={props.videoTitleShow}
        onCreateCourseButtonClick={props.onCreateCourseButtonClick}
        onCourseTitleChangeListener={props.onCourseTitleChangeListener}
        videoType={props.videoType}
        showRemoveCourse={props.showRemoveCourse}
        onRemoveCourseClick={props.onRemoveCourseClick}
      />
      break;
    case 'radio':
      //Log(props);
      radio = true;
      inputElement = <RadioGroup
        styleclass='Horizontal'
        radioButtons={props.options}
        clicked={props.changed}
        inputIdentifier={props.inputIdentifier}
      />
      break;
    default:
      inputElement = <input style={{ textAlign: props.textAlign }} className={classes.InputElement}
        {...props.elementConfig}
        value={props.value}
        onChange={(e) => props.changed(e)}
        disabled={props.disabled} />;
      break;
  }

  var afterText = ((props.elementType === 'textarea' || props.elementType === 'markdown') && !IsStringEmpty(props.afterText)) ?
    <p className={classes.AfterText}>{props.afterText + (props.value ? ' characters left' : ' characters')}</p>
    : null;
  var errorMessage = (props.showError) ? (
    <div className={classes.HorizontalAlign}>
      <p className={classes.ErrorMessage}> {props.error} </p>

      {!IsStringEmpty(props.tooltip) ? <div className={classes.NonMobileOnly}><img alt="Info Icon" src={infoIcon} className={classes.InfoIcon} onClick={() => props.onDesktopTooltipClicked(props.tooltip, props.label)} /></div> : null}

      {
        !IsStringEmpty(props.tooltip) ?
          <div title={props.tooltip} className={classes.MobileOnly}>
            <img alt="Info Icon" src={infoIcon} className={classes.InfoIcon} onClick={() => props.onMobileTooltipClicked(props.tooltip)} />
          </div>
          : null
      }
    </div>
  ) : <div className={classes.HorizontalAlign}></div>;
  const styleClasses = [classes.Input];

  styleClasses.push(textAreaInput ? classes.TextAreaInput : null);
  styleClasses.push(dropdown ? classes.DropDown : null);
  styleClasses.push(radio ? classes.Radio : null);
  styleClasses.push(props.disabled ? classes.Disabled : null);
  styleClasses.push(markdown ? classes.Markdown : null);

  if (markdown) {
    if (props.touched || !IsStringEmpty(props.value)) {
      styleClass.pop();
      styleClass.push(classes.MarkdownLabelActive);
    }

    if (IsStringEmpty(props.value) || props.value < 0) {
      styleClass.pop();
      styleClass.push(classes.MarkdownLabel);
    }
  }

  return (
    <div className={styleClasses.join(' ')}>
      {
        props.labelForEditRounds
          ? <label className={classes.MediumLabel}>{props.label} {props.required ? <span className={classes.Required}>*</span> : null}</label>
          : <label className={styleClass.join(' ')}>{props.label} {props.required ? <span className={classes.Required}>*</span> : null}</label>
      }
      {inputElement}
      <div className={classes.HorizontalAlign}>
        {errorMessage}
        {afterText}
      </div>
    </div>
  );
};

export default Input;